import { BaseReducer } from "./base.reducers";

let options = {};
options.resourceName='Locale';
const localeReducer = new BaseReducer(options);
export const localeReducers = (state = {}, action)=>localeReducer.item(state, action);